export default "__VITE_PUBLIC_ASSET__88999b0a__"